export function getPaginationRange(
  currentPage: number,
  itemsPerPage: number,
  totalItems: number
): { start: number; end: number } {
  if (totalItems === 0) {
    return { start: 0, end: 0 };
  }

  const start = (currentPage - 1) * itemsPerPage + 1;
  const end = Math.min(currentPage * itemsPerPage, totalItems);

  return { start, end };
}
